{
  "main": {
    "title": "Availability",
    "nazaj": "Back"
  },
  "nav": {
    "vnos": "Entry",
    "zapisi": "Records"
  },
  "labelsR": {
    "datum": "date",
    "uraOd": "start time",
    "uraDo": "end time",
    "UrejanjeZapisa": "Edit Record",
    "namenVnosa": "Select flying type",
    "namenMotorno": "flying",
    "namenJadralno": "gliding",
    "namenVleka": "towing",
    "registracija": "Registration",
    "filtriraj": "Filter",
    "isci": "Search and select",
    "izberi": "Enter to select",
    "odstrani": "Press Enter to remove",
    "neObstaja": "I can't find what you're looking for",
    "izbrano": "Selected",
    "praznaLista": "No vessels to display"
  },
  "obvestila": {
    "casVnosa": "Correct the times! The start time cannot be later than the end time.",
    "praznoPlovilo": "You haven't selected any vessel. Please select a vessel.",
    "prazenDatum": "Entry date is empty! Please select the desired date.",
    "opomba": "Note"
  },
  "buttons": {
    "vnesiZapis": "Add Entry",
    "urediZapis": "Update",
    "brisiZapis": "Delete",
    "brisiIzbiro": "Clear"
  }
}